import {
  bugsnagClient,
  bugsnagError,
  bugsnagInfo,
  bugsnagWarn,
  configureBugsnagClient
} from 'web-services/bugsnag';
import {
  userIsLoggedIn,
  userEmail,
  getUserId
} from 'redux/User';

/**
 * This function is invoked prior to sending bug notifications to bugsnag.
 * Here we can dynamically inject userId and other relevant information.
 * For custom/handled errors, this can be overridden in the options param of notify.
*/
const beforeSend = report => {
  // If available, send user information.
  // Here, we are assuming that the redux store has
  // been made available globally (see entry index.js).
  // We are also using direct knowledge of the state shape
  // here to avoid circular dependencies.
  if (window.modsyStore) {
    const state = window.modsyStore.getState();
    const userLoggedIn = userIsLoggedIn(state);
    const userId = getUserId(state);
    const email = userEmail(state);
    if (userLoggedIn) {
      report.user = {
        id: userId,
        email
      };
    }
  }
};

/**
 * Configure the bugsnag client for our application.
 */
configureBugsnagClient({
  appEnv: process.env.REACT_APP_ENV,
  appVersion: process.env.REACT_APP_VERSION || 'local',
  beforeSend
});

/**
 * Attach bugsnag client to global window object
 * so that we can easily window.bugsnag.notify() anywhere.
 *
 * TODO: this couples the implementation to DOM and makes it
 * not platform agnostic. We should remove all references to
 * window.bugsnag in the code and just import it or investigate
 * using the Provider pattern.
 */
window.bugsnag = bugsnagClient;

// We will wrap the app with an error boundary that
// reports unhandled errors to bugsnag.
const BugsnagErrorBoundary = bugsnagClient.getPlugin('react');

/**
 * Re-export the bugsnag helpers for use by the app.
 */
export {
  bugsnagClient,
  bugsnagError,
  bugsnagInfo,
  bugsnagWarn,
  BugsnagErrorBoundary
};
